﻿

export function CookieAccept() {
    if (document.getElementById("acceptcookies")) {
        const cookieButton = document.getElementById("acceptcookies");
        const cookieContainer = document.getElementById("cookies");
        const coverageCheckerSpecial = document.querySelector(".coverage-checker-special");
        if (localStorage.getItem("cookieAccept") !== null) {
            cookieContainer.classList.add('hidden');
            if (coverageCheckerSpecial !== null) {
              coverageCheckerSpecial.classList.add('show');
            }
        } else if (cookieButton !== null) {
            cookieContainer.classList.remove('hidden');
            cookieButton.addEventListener("click", () => {
                localStorage.setItem("cookieAccept", "true");
                cookieContainer.classList.add('hidden');
                if (coverageCheckerSpecial !== null) {
                  coverageCheckerSpecial.classList.add('show');
                }
            });
        }
    }
}